import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import WhatsAppIcon from "../components/common/WhatsAppIcon";

const Layout = () => {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
      <WhatsAppIcon />
    </>
  );
};

export default Layout;
